import React from 'react';
import envConfig from '../../../config/env';

/**
 * 20210126 自動職缺零筆 也不顯示
 */
class CompanyJobs extends React.Component {

    constructor(props){
        super(props);
        this.state={};
    }

    componentDidMount(){
        const cid = this.props.match.params.cid;
        this.props.getPositionList(cid, this.props.themeNum);
		this.props.getPositionGrpList(cid, this.props.themeNum);
		this.props.getkind00(cid);
    }

    render(){
		const { positionGrpData } = this.props.positionGrpReducer;
        const { positionData } = this.props.positionReducer;
		const { kind00Data } = this.props.kind00Reducer;
		const cid = this.props.match.params.cid;
		let companyurl = "https://www.1111.com.tw/corp/" + cid + "/#recruitment-company-point";
		let isAutoPosition=0;//add 20201207
		let positionURL2 = "https://www.1111.com.tw/job/";
        let owlLists = [];
		const limitCount=envConfig.PositionCount;

        if(positionGrpData && positionGrpData.length > 0){
            positionGrpData.forEach( element  => {
            isAutoPosition=element.position_IsAuto;
            })     
        }
		if(isAutoPosition===0){
			Array.isArray(positionData) && positionData.filter( data => data.position_group === "1").forEach((element, index) => {
				let positionURL = positionURL2+ element.eNo + "/";
                owlLists.push(
					<div key={index} className="fancy-box fancy-box-offer fancy-box-heading-sm">	
						<div className="fancy-box-cell fancy-box-header">	
						<a target='_blank' rel='noopener noreferrer' href={positionURL} >		
							<h3 className="text-primary">{element.position_name}</h3>
							<p className="position_matter-line">{element.position_matter}</p></a>						
						</div>								
						<div className="fancy-box-cell" data-text="">
							<p>{element.position_workCity}</p>
						</div>								
						<div className="fancy-box-cell" data-text="">
							<b>{element.position_salary}</b>
						</div>								
						<div className="fancy-box-cell" data-text="加入">
							<a target='_blank' rel='noopener noreferrer' href={positionURL} className="btn btn-md btn-bordered wide text-uppercase font-weight-bold lh-15">
								<span>
									<span className="btn-txt">應徵</span>
								</span>
							</a>
						</div>												
					</div>
				)
			})
		}
		else if(isAutoPosition===1){   
			Array.isArray(kind00Data) && kind00Data.forEach((element, index) => {
				let positionURL = positionURL2+ element.eNo + "/";
				if(index < limitCount){
					owlLists.push(
						<div key={index} className="fancy-box fancy-box-offer fancy-box-heading-sm">	
							<div className="fancy-box-cell fancy-box-header">	
							<a target='_blank' rel='noopener noreferrer' href={positionURL} >	
								<h3 className="text-primary">{element.Position}</h3>
								<p className="position_matter-line">{element.Matter}</p></a>						
							</div>								
							<div className="fancy-box-cell" data-text="">
								<p>{element.WorkCity}</p>
							</div>								
							<div className="fancy-box-cell" data-text="">
								<b>{element.Salary}</b>
							</div>								
							<div className="fancy-box-cell" data-text="加入">
								<a target='_blank' rel='noopener noreferrer' href={positionURL} className="btn btn-md btn-bordered wide text-uppercase font-weight-bold lh-15">
									<span>
										<span className="btn-txt">應徵</span>
									</span>
								</a>
							</div>												
						</div>
					)
				}                
			})
		}	

		return (			
			
			<section id="jobs" className="vc_row pt-30 pb-10" 
					 style={((isAutoPosition===0 && positionData.length <= 0) 
					 || (isAutoPosition===1 && (kind00Data.length <= 0 || (kind00Data.length===1 && kind00Data[0].oNo===0)))
					 ) ? {display: 'none'} :{}}>
			<style>
			  {((isAutoPosition===0 && positionData.length <= 0) 
			  || (isAutoPosition===1 && (kind00Data.length <= 0 || (kind00Data.length===1 && kind00Data[0].oNo===0)))
			  ) && `.job-display {display:none !important;}`}
            </style> 		
			<div className="container">
						<div className="row">

							<div className="lqd-column col-md-12">

								<div className="fancy-box fancy-box-offer fancy-box-offer-header">

									<div className="fancy-box-header fancy-box-cell">
										<h3>熱門職缺</h3>
									</div>
								
									<div className="fancy-box-cell">
										<h6>地點</h6>
									</div>
								
									<div className="fancy-box-cell">
										<h6>薪資</h6>
									</div>
								
							
									<div className="fancy-box-cell">
										<p></p>
									</div>
									
								</div>
								{owlLists}
								{/* {Array.isArray(positionData) && positionData.filter( data => data.position_group === "1").map((element, index) => {
									let positionURL = "https://www.1111.com.tw/job/"+ element.eNo + "/";
															
									return(

								<div key={index} className="fancy-box fancy-box-offer fancy-box-heading-sm">	
									<div className="fancy-box-cell fancy-box-header">		
										<h3 className="text-primary">{element.position_name}</h3>
										<p className="position_matter-line">{element.position_matter}</p>						
									</div>
								
									<div className="fancy-box-cell" data-text="">
										<p>{element.position_workCity}</p>
									</div>
								
									<div className="fancy-box-cell" data-text="">
										<p><strong>{element.position_salary}</strong></p>
									</div>
								
									
									
									<div className="fancy-box-cell" data-text="加入">
										<a target='_blank' rel='noopener noreferrer' href={positionURL} className="btn btn-md btn-bordered wide text-uppercase font-weight-bold lh-15">
											<span>
												<span className="btn-txt">應徵</span>
											</span>
										</a>
									</div>
									
								</div>

									)

								})} */}

							</div>

						</div>
							<div className="row">

								<div className="lqd-column col-sm-6 mb-3 mb-md-0 text-left">

									<a target='_blank' rel='noopener noreferrer' href={companyurl} className="btn btn-solid text-uppercase circle btn-bordered border-thin font-size-16 font-weight-semibold" >
										<span>
											<span className="btn-txt">所有職缺</span>
										</span>
									</a>

								</div>


							</div>
					</div>
				</section>

		)

	}
}

export default CompanyJobs;